// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0o+id","hideContainer":"styles_hideContainer__zEc-s","mainContainer":"styles_mainContainer__iTub4","content":"styles_content__NPB8f"};